/******************************************************
 TODO: update to use UUID package once the issue related to the following 
 comment is resolved. 

 https://github.com/react-native-community/react-native-webview/issues/1312#issuecomment-613359818
********************************************************/

export default ():string => {
	let d = new Date().getTime();

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});
}

